import { GlAvatarLink, GlSprintf, GlLoadingIcon } from '@gitlab/ui';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import HiddenBadge from '~/issuable/components/hidden_badge.vue';
import LockedBadge from '~/issuable/components/locked_badge.vue';
import { NAMESPACE_PROJECT } from '~/issues/constants';
import { __, s__ } from '~/locale';
import ConfidentialityBadge from '~/vue_shared/components/confidentiality_badge.vue';
import ImportedBadge from '~/vue_shared/components/imported_badge.vue';
import TimeAgoTooltip from '~/vue_shared/components/time_ago_tooltip.vue';
import glFeatureFlagsMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import workItemByIidQuery from '../graphql/work_item_by_iid.query.graphql';
import { findNotesWidget, findRequesterWidget } from '../utils';
import WorkItemStateBadge from './work_item_state_badge.vue';
import WorkItemTypeIcon from './work_item_type_icon.vue';
export default {
    name: 'WorkItemCreatedUpdated',
    components: {
        HiddenBadge,
        ImportedBadge,
        LockedBadge,
        GlAvatarLink,
        GlSprintf,
        TimeAgoTooltip,
        WorkItemStateBadge,
        WorkItemTypeIcon,
        ConfidentialityBadge,
        GlLoadingIcon
    },
    mixins: [
        glFeatureFlagsMixin()
    ],
    props: {
        fullPath: {
            type: String,
            required: true
        },
        workItemIid: {
            type: String,
            required: false,
            default: null
        }
    },
    data () {
        return {
            workItem: {}
        };
    },
    computed: {
        author () {
            return this.workItem?.author ?? {};
        },
        authorId () {
            return getIdFromGraphQLId(this.author.id);
        },
        createdAt () {
            return this.workItem?.createdAt || '';
        },
        createdMessage () {
            if (findRequesterWidget(this.workItem)) {
                return s__('WorkItem|created %{timeAgo} via email');
            }
            if (this.workItem.externalAuthor && this.author.name) {
                return __('created %{timeAgo} by %{email} via %{author}');
            }
            if (this.author.name) {
                return __('created %{timeAgo} by %{author}');
            }
            return __('created %{timeAgo}');
        },
        workItemState () {
            return this.workItem?.state;
        },
        workItemType () {
            return this.workItem?.workItemType?.name;
        },
        workItemTypeIconName () {
            return this.workItem?.workItemType?.iconName;
        },
        workItemMovedToWorkItemUrl () {
            return this.workItem?.movedToWorkItemUrl;
        },
        workItemDuplicatedToWorkItemUrl () {
            return this.workItem?.duplicatedToWorkItemUrl;
        },
        workItemPromotedToEpicUrl () {
            return this.workItem?.promotedToEpicUrl;
        },
        isDiscussionLocked () {
            return findNotesWidget(this.workItem)?.discussionLocked;
        },
        isWorkItemConfidential () {
            return this.workItem?.confidential;
        },
        isLoading () {
            return this.$apollo.queries.workItem.loading;
        }
    },
    apollo: {
        workItem: {
            query: workItemByIidQuery,
            variables () {
                return {
                    fullPath: this.fullPath,
                    iid: this.workItemIid,
                    useWorkItemFeatures: Boolean(this.glFeatures?.workItemFeaturesField)
                };
            },
            skip () {
                return !this.workItemIid;
            },
            update (data) {
                return data.namespace?.workItem ?? {};
            }
        }
    },
    NAMESPACE_PROJECT
};
